import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import apiPaths from 'constants/api-paths';
import { appDb } from 'dexie/app.db';
import { generateURL } from 'helpers/api-path.helper';
import { switchMap, from, catchError, of } from 'rxjs';
import { CacheKeyService } from '../cache-key.service';
import { DBService } from '../db.service';

@Injectable({
  providedIn: 'root',
})
export class WarehouseReportMetaApiService {
  protected dbService = inject(DBService);
  protected cacheKeyService = inject(CacheKeyService);
  protected http = inject(HttpClient);
  constructor() {}
  getMeta() {
    return this.http.get(generateURL(apiPaths.warehouseReportMeta)).pipe(
      switchMap((data: any) => {
        return from(appDb.warehouseReportMeta.bulkPut(data));
      }),
      catchError(() => {
        return of(null);
      })
    );
  }
}
